<template>
  <b-modal
    id="modal-leave-view"
    no-close-on-backdrop
    hide-footer
    centered
    hide-header
    body-class="modal-leave-view"
    content-class="modal-leave-view"
  >
    <template #default>
      <b-container fluid>
        <b-row class="justify-content-center mt-2">
          <b-col cols="auto">
            <b-icon
              icon="exclamation-triangle-fill"
              style="color: #d09306; width: 50px; height: 50px"
            ></b-icon>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mt-3">
          <b-col cols="6">
            <p class="text1-modal-leave-view">Tem certeza que deseja sair?</p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5 mt-3">
          <b-col cols="6">
            <p class="text2-modal-leave-view">
              As informações de cadastro <br />
              não serão salvas
            </p>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-3">
          <b-col cols="auto">
            <button
              class="button-modal-leave-view btn-one"
              @click="$bvModal.hide('modal-leave-view')"
            >
              VOLTAR
            </button>
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-2">
          <b-col cols="auto">
            <button
              class="button-modal-leave-view btn-two"
              type="button"
              @click="responseModal()"
            >
              SAIR
            </button>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
export default {
  methods: {
    responseModal() {
      this.$emit('responseModalLeaveView');
    },
  },
};
</script>

<style>
.modal-leave-view {
  background-color: #e8e8e8;
  padding: 8px;
  border-radius: 12px;
  border: none;
}

.text1-modal-leave-view,
.text2-modal-leave-view,
.button-modal-leave-view {
  font-family: 'Inter', sans-serif;
  font-style: normal;
}

.text1-modal-leave-view,
.text2-modal-leave-view {
  text-align: center;
}

.text1-modal-leave-view {
  font-size: 24px;
  font-weight: 900;
  color: #d09306;
}

.text2-modal-leave-view {
  font-weight: 300;
  font-size: 16px;
  color: black;
}

.button-modal-leave-view {
  min-width: fit-content;
  width: 196px;
  height: 28px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.35em;
  font-weight: 700;
  border-radius: 13px;
}

.button-modal-leave-view:focus {
  outline: none;
}

.btn-one {
  color: #272727;
  border: 1px solid #272727;
  background-color: transparent;
}

.btn-two {
  color: white;
  border: none;
  background-color: #d09306;
}
</style>
